module.exports = __webpack_public_path__ + "img/slide5.e9a5055e.jpg";